import { render, staticRenderFns } from "./AlertSystem.vue?vue&type=template&id=71daad67"
import script from "./AlertSystem.vue?vue&type=script&lang=js"
export * from "./AlertSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports